module.exports = __webpack_public_path__ + "static/media/Plateau_H_2.b63c120c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/Plateau_H_2.svg
// module id = 784
// module chunks = 0